import React from 'react';
import * as Card from '../../v2BaseComponents/Card';
import { getIntl } from '../../../utils/intl';
import urls from '../../../utils/urls';
import { getPermissionsDescription } from '../../../utils/evaluatePermissions';
import { useCollaborator } from '../../../hooks/api/useCollaborator';
import { getFallbackFromName } from '../../v2BaseComponents/Avatar';
import { getCollaboratorName } from '../../../utils/collaboratorUtils';

const intl = getIntl('CollaboratorCard', {
    profileAccess: 'Profile Access',
    view: 'View',
    edit: 'Edit',
    none: 'None',
    permissions: 'Permissions: {permissions}',
});

export type CollaboratorCardOwnProps = {
    medicalProfileId: string;
    collaboratorId: string;
    onPress?: () => void;
    isDisabled?: boolean;
    skeletonFallback?: boolean;
};

export type CollaboratorCardProps = CollaboratorCardOwnProps;

const CollaboratorCard: React.FC<CollaboratorCardProps> = (props) => {
    const { isLoading, collaborator } = useCollaborator({
        medicalProfileId: props.medicalProfileId,
        collaboratorId: props.collaboratorId,
    });

    if (!collaborator || isLoading) return props.skeletonFallback ? <Card.CardSkeleton /> : null;

    const getDetails = (): string => {
        // @ts-expect-error TS2345
        return intl('permissions', { permissions: getPermissionsDescription(collaborator.appPermissions) });
    };

    return (
        <Card.Card onPress={props.onPress} isDisabled={props.isDisabled}>
            <Card.CardLeftContent
                leftContent={
                    <Card.CardLoadableAvatar
                        size="md"
                        fallbackName={getFallbackFromName(getCollaboratorName(collaborator))}
                        avatarUrl={urls.api.collaborators.collaboratorAvatar(
                            props.medicalProfileId,
                            collaborator.medicalProfileCollaboratorId,
                        )}
                    />
                }
            >
                <Card.CardContent>
                    <Card.CardHeader>{getCollaboratorName(collaborator)}</Card.CardHeader>
                    <Card.CardBody2>{getDetails()}</Card.CardBody2>
                </Card.CardContent>
            </Card.CardLeftContent>
        </Card.Card>
    );
};

export default React.memo(CollaboratorCard);
